export enum ProductCategoryIds {
    PATIO = 3000,
    SMART_HOUSE = 4999,
}

interface BaseProductCategoryDto {
    id: number;
    name: string;
    available: boolean;
    sortOrder: number;
}

export type SubProductCategoryDto = BaseProductCategoryDto;

export interface ProductCategoryDto extends BaseProductCategoryDto {
    productCategories: Array<SubProductCategoryDto>;
}
